export function formAnimation() {

    $(".wpcf7-form input, .wpcf7-form textarea").focus(function() {
        $(this).parent().siblings('label').addClass('has-value');
        $(this).addClass('has-value');
    })

    // blur input fields on unfocus + if has no value
    .blur(function() {
        let text_val = $(this).val();
        if(text_val === "") {
            $(this).parent().siblings('label').removeClass('has-value');
            $(this).removeClass('has-value');
        }
    });

    $(".wpcf7-form select").change(function() {
        $(this).parent().siblings('label').addClass('has-value');
        $(this).addClass('has-value');
    });

    $('option[value=""]').attr("disabled", "disabled");


    // select virtual or normal school tour
    const selector = document.querySelector('.js-school-trip');
    if (selector) {
        selector.addEventListener("change", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('.js-school-trip-form').fadeOut();
            const id = e.currentTarget.value
            $('#' + id).fadeIn();
        });
    }

}
